import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.IntegrationModule.CompanyMismatchPopup', {
    title: 'Connection to different {integrationName} organisation is not allowed ',
    description: `Bounded {integrationName} org can’t be changed for ApprovalMax org after initial connection. Please connect to initial {integrationName} org or create a new ApprovalMax org.
    Should you have any questions, please <supportlink>contact us</supportlink>.`,
    cancelButtonText: 'Cancel',
});
